<template>
  <div class="member-wrap">
    <div class="header-wrap"></div>
    <div class="content-wrap">
      <template v-if="!loading">
        <component
          :is="item.display_code"
          v-for="item of categoryList"
          :key="item.id"
          :item="item"
          :type="item.display_code"
          :namespace="namespace"
          :allBenefitList="benefitList"
        />
      </template>
    </div>
  </div>
</template>

<script>
import {
  defineComponent,
  onMounted,
  ref,
  computed,
} from "@vue/composition-api";
import Vue from "vue";

import { useStore } from "@/components/use/base";

import { jsonSafeParse } from "@/utils";
import { getNamespaceBenefit } from "@/apis/home";
import { getIndexCategory, getIndexClassList } from "@/apis/product";

import JxmBenefit from "../../member/component/JxmBenefit.vue";

const vm = Vue.prototype;

export default defineComponent({
  components: {
    JxmBenefit,
  },
  setup() {
    const store = useStore();

    const categoryList = ref([]);
    const benefitList = ref([]);
    const loading = ref(true);

    const packageName = computed(() => store.state.namespaceInfo.package);
    const namespace = computed(() => store.state.namespace);
    const isMember = computed(() => store.state.isMember);

    const initDataPage = async () => {
      const packageMap = jsonSafeParse(vm.$getConfigValue("BJ_CARD_MAP"));
      const page = packageMap[namespace.value].page;
      const { data: categoriesData } = await getIndexCategory({
        namespace: page,
        opened_page: "member",
        source: "default",
      });
      const { data: productData } = await getIndexClassList({
        title: categoriesData.map((v) => v.name).join(","),
        opened_page: "member",
        namespace: page,
      });
      categoryList.value = categoriesData
        .map((value) => ({
          ...value,
          productInfo: productData[value.name] || [],
        }))
        .filter((item) => item.display_code !== "onlineOrdering");

      const { data } = await getNamespaceBenefit({
        package: packageName.value.split(",")[0],
        namespace: namespace.value,
      });
      benefitList.value = data.map((item) => item.benefit_type);
    };

    onMounted(async () => {
      const loadingPage = vm.$loading();
      loading.value = true;
      try {
        await initDataPage();
      } catch (error) {
        console.log(error);
      } finally {
        loading.value = false;
        loadingPage.clear();
      }
    });

    return {
      categoryList,
      loading,
      namespace,
      isMember,
      benefitList,
    };
  },
});
</script>

<style lang="less" scoped>
.member-wrap {
  overflow: hidden;
  background: linear-gradient(270deg, #f7f1db 0%, #ffffff 50.68%, #cae0fe 100%);
}

.header-wrap {
  width: 375px;
  height: 168px;
  background-image: url("https://common-h5-dev.xiangshuheika.com/static/upload/2026626ca3b8eb24c04aa4ba503e4ab04d2759.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;

  .card-message {
    position: absolute;
    left: 32px;
    top: 111px;
    font-weight: 400;
    font-size: 12px;
    color: #fcf4e4;
  }
}

.content-wrap {
  overflow: hidden;
  min-height: calc(100vh - 168px);
  background: linear-gradient(180deg, #fcfbf4 0%, #f4f6f9 100%);
  border-radius: 16px 16px 0 0;
}

.action-wrap {
  margin: 0 auto;
  margin-top: 40px;
  margin-bottom: 31px;

  display: flex;
  align-items: center;
  width: 343px;
  height: 32px;
  background: #ffffff;
  border-radius: 8px;
  box-sizing: border-box;

  font-weight: 400;
  font-size: 15px;
  color: #333333;

  svg {
    height: 20px;
    width: 22px;
    margin-right: 9px;
  }

  .order {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }

  .line {
    width: 1px;
    height: 23px;
    background: #e4e4e4;
  }

  .service {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
  }
}
</style>
